import { useEffect } from 'react'
import { PaakConversionPageLoader } from 'sdk-paak-conversion-page'

export const usePaakAd = ({ campaign, user }: { campaign: Api.CampaignResBody; user: Api.UserResBody }) => {
  useEffect(() => {
    // 広告効果計測
    const paakAd = () => {
      if (user && campaign) {
        if (campaign.ad) {
          new PaakConversionPageLoader({
            backendEndpoint: process.env.NEXT_PUBLIC_AD_BACKEND_API_ENDPOINT,
            backendApiKey: campaign.adKey,
            isSetScript: false,
          })
            .loadWithGeo()
            .then((res) => {
              res
                .onConversion({
                  userId: user.user.id,
                })
                .catch((v) => console.log(v))
            })
        }
      }
    }
    paakAd()
  }, [user, campaign])
}
